import { action } from '@ember/object';
import Component from '@glimmer/component';

import FormSelectComponent from 'webapp/components/form/select';
import ToolTipWithIconComponent from 'webapp/components/tool-tip-with-icon';

import type CustomMetricSetupFormApiMetricBuilder from 'webapp/models-custom/custom-metric-setup-form/api-metric-builder';

interface Args {
	form: CustomMetricSetupFormApiMetricBuilder;
	isDisabled: boolean;
	theme: string;
}

export default class CustomQuerySetupApiMetricBuilderPaginationComponent extends Component<Args> {
	get options(): LabelValuePairString[] {
		return this.args.form.paginationOptions.map((item) => {
			return {
				value: item.id || '',
				label: item.name,
			};
		});
	}

	get selectedDescription(): string {
		const option = this.args.form.paginationOptions.find(
			(item) => item.id === this.args.form.pagination || null,
		);
		return option?.description || '';
	}

	@action
	change(value: string): void {
		this.args.form.pagination = value;
	}
	<template>
		<div class="row">
			<div class="size-1 item">
				<label>Pagination method</label>
			</div>
			<div class="size-2 item same-row">
				<FormSelectComponent
					name="pagination"
					@selected={{@form.pagination}}
					@options={{this.options}}
					@onChange={{this.change}}
					@isNumeric={{false}}
					@isRequired={{true}}
					@isDisabled={{@isDisabled}}
					@theme={{@theme}}
				/>
				{{#if this.selectedDescription}}
					<ToolTipWithIconComponent
						@text={{this.selectedDescription}}
						@spaceRight={{true}}
					/>
				{{/if}}
			</div>

		</div>
	</template>
}
